<template>
  <div class="block">
    <div class="block-title">统计数据</div>
    <el-form :model="searchForm" class="search-form">
      <el-form-item label="推广位名称">
        <el-select v-model="searchForm.code" placeholder="请选择推广位名称">
          <el-option v-for="item in promoteList" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="应用名">
        <el-select v-model="searchForm.referMiniKey" placeholder="请选择应用名">
          <el-option v-for="item in referMiniList" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="dateTime" class="form-item" label-width="100">
        <el-date-picker v-model="dateTime" type="daterange" range-separator="-" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="changeTime"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-tooltip class="item" effect="dark" placement="top">
          <i :style="{ marginLeft: '5px', color: '#909399' }" class="el-icon-question"></i>
          <div slot="content">
            <p>选择时间后，列表中出现的是各推广位对应时间内的产生的数据，注册粉丝数不变</p>
          </div>
        </el-tooltip>
      </el-form-item>

      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
        <el-button @click="onFormExport">导出数据</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar">
      <!--查询结果汇总 -->
      <div class="promote">
        <div class="promote-item" v-for="(item, index) in totalList" :key="index">
          <div class="promote-item__name">
            {{ item.name }}
          </div>
          <div class="promote-item__value">
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
    <!-- 表格-->
    <el-table ref="table" header-row-class-name="header" border highlight-current-row row-key="id"
      :data="table.dataSource" v-loading="table.loading" @sort-change="onSortChange">
      <el-table-column label="推广位名称" min-width="150">
        <template slot-scope="{ row }">
          <div> {{ row.name }}</div>
          <div> （ID:{{ row.code }}）</div>
        </template>
      </el-table-column>
      <el-table-column label="应用名" min-width="80" prop="referMiniName">
      </el-table-column>
      <el-table-column sortable="custom" min-width="120" prop="focusUserCount">
        <template slot="header">
          <span>注册粉丝数</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <i class="el-icon-question"></i>
            <div slot="content">
              <p>指注册的粉丝总数，不支持时间筛选</p>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="下单粉丝数" sortable="custom" min-width="120" prop="orderUserCount">
      </el-table-column>
      <el-table-column sortable="custom" min-width="120" prop="orderSuccessCount">
        <template slot="header">
          <span>成交订单数</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <i class="el-icon-question"></i>
            <div slot="content">
              <p>指付款成功的订单数（含退款订单）</p>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" min-width="150" prop="proxyCommissionAmountStr">
        <template slot="header">
          <span>佣金收入（元）</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <i class="el-icon-question"></i>
            <div slot="content">
              <p>指已结算订单实际佣金之和（含结算后关闭的订单）</p>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="推广成本（元）" sortable="custom" min-width="150" prop="costPriceAmountStr">
      </el-table-column>
      <el-table-column label="回本率" sortable="custom" min-width="150" prop="returnRate">
        <template slot-scope="{ row }">
          <div>{{ row.returnRate }}%</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini()

const searchParams = {
  startDate: "", // 开始日期
  endDate: "", // 结束日期
  referMiniKey: '',// 应用名
  code: "", // 推广位名称
};

export default {
  data() {
    return {
      totalList: [ // 统计
        {
          name: '查询结果汇总',
          value: ''
        },
        {
          name: '注册粉丝数：',
          value: 0,
          key: "focusUserCountTotal"
        },
        {
          name: '下单粉丝数：',
          value: 0, key: "orderUserCountTotal"
        },
        {
          name: '成交订单数：',
          value: 0, key: "orderSuccessCountTotal"
        },
        // {
        //   name: '销售额（元）：',
        //   value: 0, key: "saleAmountTotalStr"
        // },
        {
          name: '佣金收入（元）：',
          value: 0, key: "proxyCommissionAmountTotalStr"
        },
        {
          name: '推广成本（元）：',
          value: 0, key: "costPriceAmountTotalStr"
        },
      ],
      referMiniList: [ // 应用名列表 含全部
      ],
      promoteList: [ // 推广位列表
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dateTime: [], // 日期
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      sortField: '', //排序字段：1:注册粉丝数，2:下单用户数，3:成交数，4:销售额，5:佣金收入，6:推广成本，7:回报率
      sortType: '',// 排序类型-降序desc，升序asc
      table: {
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
    };
  },
  mounted() {
    this.getPromoteList();
    this.getMiniAppList()
    this.freshTable();
  },
  methods: {
    // 排序
    onSortChange(column) {
      let keyObj = {
        focusUserCount: 1,
        orderUserCount: 2,
        orderSuccessCount: 3,
        saleAmountStr: 4,
        proxyCommissionAmountStr: 5,
        costPriceAmountStr: 6,
        returnRate: 7,
      }
      let sortObj = {
        'descending': 'desc',
        'ascending': 'asc'
      }
      this.sortField = keyObj[column.prop]
      this.sortType = sortObj[column.order]
      console.log(this.sortField, 'this.sortField')
      console.log(this.sortType, ' this.sortType')
      this.freshTable()
    },
    //获取推广位名称列表
    async getPromoteList() {
      const data = await MiniModel.getPromoteList({})

      if (data.data.code === 200) {

        this.promoteList = data.data.data.map((item) => (
          {
            value: item.code,
            label: item.name
          }
        ))
        this.promoteList.unshift({
          value: '',
          label: '全部'
        })
      }

    },
    // 获取应用名列表
    async getMiniAppList() {
      const data = await MiniModel.getMiniAppList({})
      if (data.data.code === 200) {

        this.referMiniList = data.data.data.map((item) => (
          {
            value: item.appKey,
            label: item.appName
          }
        ))
        this.referMiniData = JSON.parse(JSON.stringify(this.referMiniList))
        this.referMiniList.unshift({
          value: '',
          label: '全部'
        })
      }
    },
    // 改变日期
    changeTime(arr) {
      if (arr && arr.length) {
        this.searchForm.startDate = arr[0];
        this.searchForm.endDate = arr[1];
      } else {
        this.searchForm.startDate = "";
        this.searchForm.endDate = "";
      }
    },
    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 表单重置`
    onFormReset() {

      this.dateTime = [];
      this.searchForm = Object.assign({}, searchParams);
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },

    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      const data = await MiniModel.statSearch({
        ...this.pagination,
        ...this.searchForm,
        sortField: this.sortField,
        sortType: this.sortType
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.totalList.forEach((item) => {
          item.value = data.data.data[item.key]
        })
        this.table.dataSource = data.data.data.page.list;
        this.table.total = data.data.data.page.total;
      }
    },
    // 转换数据
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
    onFormExport() {
      MiniModel.statExport({
        ...this.searchForm,
        sortField: this.sortField,
        sortType: this.sortType
      }).then((res) => {
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        console.log("blob", blob);
        let url = window.URL.createObjectURL(blob);
        console.log("url", url);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(blob);
        a.download = "统计数据" + this.formatDate(new Date()) + ".xls";
        a.click();
        window.URL.revokeObjectURL(url);
        this.$message({
          message: "导出成功",
          type: "success",
        });
      });
    }
  },
};
</script>
<style lang="less" scoped>
.promote {
  width: 100%;
  display: flex;
  padding: 14px 0;
  background: #F5F5FA;
  margin-top: 10px;


  &-item {
    margin-left: 20px;
    display: flex;

    &__name {
      color: #666666;
    }

    &__value {
      color: #FF8622;

    }
  }

  &-item:last-child {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/statisticalData/index.vue